import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.52803 5.4C8.17891 5.4 7.10194 6.41761 7.10194 7.65448C7.10194 7.97612 7.38692 8.22415 7.72201 8.22415C8.0571 8.22415 8.34208 7.97612 8.34208 7.65448C8.34208 7.03075 8.88185 6.53933 9.52803 6.53933C10.1742 6.53933 10.714 7.03075 10.714 7.65448C10.714 8.14323 10.3804 8.55428 9.92345 8.70627C9.70201 8.77993 9.45026 8.91433 9.25262 9.11136C9.05408 9.30927 8.90796 9.57299 8.90796 9.90091C8.90796 10.2225 9.19294 10.4706 9.52803 10.4706C9.86148 10.4706 10.1453 10.225 10.1481 9.90564C10.1499 9.90207 10.1554 9.89299 10.1697 9.87856C10.2036 9.84425 10.2655 9.80428 10.346 9.77751C11.2871 9.46447 11.9541 8.62964 11.9541 7.65448C11.9541 6.41761 10.8771 5.4 9.52803 5.4Z",
			fill: "#666B75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.52803 11.1331C9.0932 11.1331 8.72736 11.4544 8.72736 11.8665C8.72736 12.2786 9.0932 12.6 9.52803 12.6C9.96286 12.6 10.3287 12.2786 10.3287 11.8665C10.3287 11.4544 9.96286 11.1331 9.52803 11.1331Z",
			fill: "#666B75"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.50195 16.125C13.437 16.125 16.627 12.935 16.627 9C16.627 5.06497 13.437 1.875 9.50195 1.875C5.56692 1.875 2.37695 5.06497 2.37695 9C2.37695 12.935 5.56692 16.125 9.50195 16.125ZM15.4395 9C15.4395 12.2792 12.7811 14.9375 9.50195 14.9375C6.22276 14.9375 3.56445 12.2792 3.56445 9C3.56445 5.72081 6.22276 3.0625 9.50195 3.0625C12.7811 3.0625 15.4395 5.72081 15.4395 9Z",
			fill: "#666B75"
		})
	]
});
export default SvgIcHelp;
